import {useContext, useMemo} from 'react';

import {useLocale} from '../../../../../../provider/locale/locale-hook';
import {MainFilterContext} from '../../../../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../../../../provider/main-filter/main-filter-type';
import {useReviewCompetitorCities} from '../../../../../../service/reivew-analysis/review-cities/review-cities-hook';
import {ReviewsAndAnswersStatisticsUnitMeasurementEnum} from '../../../../../../service/reviews-and-answers-statistics/reviews-and-answers-statistics';
import {useReviewsAnalysisFilter} from '../../../reviews-analysis-hook';
import {useReviewBrands} from '../../dashboard/dashboard-hook';
import {citiesDefaultPageSize} from '../cities-page-const';
import {mergeCompetitorCompareData} from '../cities-page-helper';
import {CityTableDataType} from '../cities-page-type';
import {CitiesTable} from '../cities-table/cities-table';

export function CitiesTableCompetitor(): JSX.Element | null {
    const {getLocalizedString} = useLocale();
    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    const {competitorFilter} = useReviewsAnalysisFilter();

    const {
        result: {nameMap: reviewBrandNames},
    } = useReviewBrands();

    const compareName = useMemo(
        () => competitorFilter.brandIds.map((brand) => reviewBrandNames[brand]).join(', '),
        [competitorFilter, reviewBrandNames]
    );

    const {data, isLoading, pagination, isError} = useReviewCompetitorCities(competitorFilter, mainFilterKey, {
        initialPageSize: citiesDefaultPageSize,
    });

    const dataSource: Array<CityTableDataType> = useMemo<Array<CityTableDataType>>((): Array<CityTableDataType> => {
        return mergeCompetitorCompareData(
            data?.results || [],
            compareName || getLocalizedString('REVIEWS_ANALYSIS__DASHBOARD__SOURCES__COMPARE_BRAND_NAME')
        );
    }, [compareName, data, getLocalizedString]);

    if (isError) {
        return null;
    }

    return (
        <CitiesTable
            dataSource={dataSource}
            isInProgress={isLoading}
            pagination={pagination}
            timeUnit={competitorFilter.timeFormat || ReviewsAndAnswersStatisticsUnitMeasurementEnum.Minutes}
        />
    );
}
